export default __webpack_public_path__ + "static/media/blob_right.829e9d6f.png";